<template>
    <div class="p-fluid" style="direction: rtl">
        <div class="p-p-4 p-grid p-justify-center">
            <select-teacher class="p-col-6" navigate-buttons useStore storage-name="Schedule-teacher" @onSelect="onSelectTeacher"/>
            <Button
                    v-if="!deleteMode"
                    v-tooltip.top="'הדפסה'"
                    icon="pi pi-print"
                    class="p-col-1 p-mt-2 p-mb-3 p-d-print-none"
                    v-simple-print="'SCHEDULE'"
            />
            <Button
                    v-if="(user.role === 'ADMIN' || teacherSelected === user.id) && !deleteMode"
                    v-tooltip.top="'הסתר-דיווחים'"
                    :icon="showReport ? 'pi pi-eye-slash': 'pi pi-eye'"
                    :label="showReport ? 'הסתר דיווחים' : 'הצג דיווחים'"
                    :class="`p-button-warning regular-width p-col-1 p-mr-2 p-mt-2 p-mb-3 p-d-print-none `"
                    @click="changeShowReport"
            />
            <Button
                    id="deleteMode"
                    v-if="user.role === 'ADMIN' && !showReport"
                    v-tooltip.top="deleteMode ? 'צא ממצב מחיקה' : 'מחק משבצות זמן'"
                    :icon="deleteMode ? 'pi pi-ban': 'pi pi-trash'"
                    :label="deleteMode ? 'צא ממצב מחיקה' : ''"
                    :class="`${deleteMode ? 'regular-width p-button-secondary' : 'p-button-danger '}  p-col-1 p-mr-2 p-mt-2 p-mb-3 p-d-print-none `"
                    @click="changeDeleteMode"
            />

            <select-week useStore v-if="showReport" class="p-col-6" navigate-buttons storage-name="Schedule-teacher" @onSelect="onSelectWeek"/>

            <schedule-table :deleteMode="deleteMode" :showReport="showReport" :weekSelected="weekSelected" :teacher="teacherSelected" class="p-col-12"/>
<!--                    v-if="user.role === 'ADMIN' && !showReport "-->
<!--                    v-tooltip.top="isMultipleAllow ? 'בטל שיבוץ מקביל' : 'אפשר שיבות מקביל'"-->
<!--                    :icon="isMultipleAllow ? 'pi pi-eye-slash': 'pi pi-eye'"-->
<!--                    :label="isMultipleAllow ? 'בטל שיבוץ מקביל' : 'אפשר שיבות מקביל'"-->
<!--                    :class="`p-button-warning regular-width p-col-1 p-mr-2 p-mt-2 p-mb-3 p-d-print-none `"-->
<!--                    @click="changeIsMultipleAllow"-->
<!--            />-->
            <select-week useStore v-if="showReport" class="p-col-6" navigate-buttons storage-name="Schedule-teacher" @onSelect="onSelectWeek"/>

<!--            <schedule-table :isMultipleAllow="isMultipleAllow" :showReport="showReport" :weekSelected="weekSelected" :teacher="teacherSelected" class="p-col-12"/>-->
        </div>

    </div>
</template>

<script>

import SelectWeek from "@/components/selects/SelectWeek";
import SelectTeacher from "@/components/selects/SelectTeacher";
import ScheduleTable from "@/views/Schedule/ScheduleTeacher/ScheduleTable.vue";
import {mapState} from "vuex";
import Vue from "vue";

export default {
    components: {
        SelectTeacher,
        ScheduleTable,
        SelectWeek,
    },
    data() {
        return {
            teacherSelected: null,
            showReport: false,
            weekSelected: null,
            deleteMode: false,
            isMultipleAllow: false,
        }
    },
    computed: {

        ...mapState([
            "user",

        ])
    },
    mounted() {
        this.showReport = Vue.ls.get(`showReport_ScheduleTeacher`, null)
    },
    methods: {
        changeIsMultipleAllow(){
            this.isMultipleAllow = !this.isMultipleAllow
        },
        changeShowReport(){
            Vue.ls.set(`showReport_ScheduleTeacher`, !this.showReport)
            this.showReport = !this.showReport
        },
        changeDeleteMode(){
            // Vue.ls.set(`showReport_ScheduleTeacher`, !this.showReport)
            this.deleteMode = !this.deleteMode
        },
        onSelectTeacher(teacherSelected) {
            if (teacherSelected !== this.user.id && this.user.role !== 'ADMIN' ) this.showReport = false
            this.teacherSelected = teacherSelected
        },
        onSelectWeek(weekSelected) {
            this.weekSelected = weekSelected
        }
    },
};
</script>


<style scoped>
.regular-width {
     width: unset;
}
</style>
